import vibrateShort from "./vibrateShort";
import vibrateLong from "./vibrateLong";
export { vibrateShort, vibrateLong };
export default {
  vibrateShort: vibrateShort,
  vibrateLong: vibrateLong
};